/** Extract the last four digits from a masked, partial, or full SSN string. */
export function extractLast4FromStoredSsn(stored: string): string | null {
  const trimmed = stored.trim();
  if (!trimmed) return null;
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length === 4) return digits;
  if (digits.length >= 9) return digits.slice(-4);
  if (digits.length > 0 && digits.length < 9) return digits.slice(-4);
  return null;
}

/** True when the value is a server-side masked display (not a full editable SSN). */
export function isStoredSsnDisplayValue(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (/[•*]/.test(trimmed)) return true;
  const digits = trimmed.replace(/\D/g, "");
  return digits.length > 0 && digits.length < 9;
}

/**
 * Display string for an SSN already on file: `***-**-1234`.
 * Accepts masked API values (`•••-••-1234`), last-four-only, or full SSN
 * (only the last four are shown).
 */
export function formatStoredSsnDisplay(stored: string): string {
  const last4 = extractLast4FromStoredSsn(stored);
  if (!last4) return "";
  return `***-**-${last4}`;
}
